"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal = void 0;
const modal = () => {
    let modal = document.querySelector('[data-view="modal"]');
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (target.matches('[data-open="modal"]')) {
            modal.setAttribute('aria-hidden', 'false');
        }
        if (target.matches('[data-close="modal"]')) {
            modal.setAttribute('aria-hidden', 'true');
        }
    });
};
exports.modal = modal;
